import { render, staticRenderFns } from "./arrived.vue?vue&type=template&id=c7bd7660"
import script from "./arrived.vue?vue&type=script&lang=js"
export * from "./arrived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports